module.exports = __webpack_public_path__ + "img/87.8465680d.jpg";